<template>
  <div class="u-containar-md registerForm">
    <p>
      マイナビRESIDENTの引継ぎ利用登録が完了しました。
    </p>
    <p>
      下記リンクより<br />
      新しいマイナビRESIDENTをご利用ください。
    </p>
    <Button label="トップページへ" href="/" :handleClick="toTop" primary />
  </div>
</template>

<script lang="ts">
import { useRouter } from 'vue-router'
import Button from '@/components/elements/Button.vue'

export default {
  components: {
    Button
  },
  setup() {
    const router = useRouter()

    const toTop = () => {
      router.push({ path: '/' })
    }

    return {
      toTop
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  text-align: center;
  &:not(:last-of-type) {
    margin-bottom: 1em;
  }
}
a {
  margin-top: 2em;
}
</style>
